export const formatDate = (date) => {
  const dateToFormat = new Date(date);
  let day = dateToFormat.getDate().toString().padStart(2, "0");
  let month = (dateToFormat.getMonth() + 1).toString().padStart(2, "0"); // Adding 1 because months are zero indexed
  let year = dateToFormat.getFullYear();

  return month + "/" + day + "/" + year;
};
